<template>
  <div class="container">
    <vue-headful
      title="Projects | Rhys Matthew | Web Developer"
      description="Rhys Matthew is a Web Developer/Designer and User Interface Developer. From Web Design, Front-End Development or a CMS integrated website, Rhys can help with a range of tasks within Web Development to get your project off the ground."
      keywords="Web Developer, UI Developer, UX Design, Web Design, Front-End Development, JavaScript dev, Freelance, Web Engineer, CSS, PHP, Wordpress Developer, CMS integration, Vue, ES6 JS, Modern JavaScript, Rhys Web Developer"
      :head="{
        'meta[property=\'og:url\']': {content: 'https://rhys.digital'},
        'meta[name=\'twitter:site\']': {content: 'https://rhys.digital'},
        'link[rel=\'canonical\']': {href: 'https://rhys.digital'}
      }"
    />

    <PageHeader></PageHeader>

    <section class="section" id="projects-home">
      <div class="cards">
        <div class="mw--800">
          <div class="mb-2" v-for="projectItem in projectItems" :key="projectItem.data.id">
            <CardProject
              :key="projectItem.data.id"
              :title="projectItem.data.title"
              :description="projectItem.data.description"
              :img_srcset="projectItem.data.img.lg.url"
              :img_src="projectItem.data.img.url"
              :img_alt="projectItem.data.img.alt"
              img_aspect="aspect--3-2 aspect--1-1-mobileLandscape-down" :live_href="projectItem.data.live_link"
              :git_href="projectItem.data.git_link" :accomplishments="projectItem.data.accomplishments">
            </CardProject>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Page header
import PageHeader from '../components/page-header/PageHeader'

// Cards
import CardProject from '../components/cards/CardProject.vue'

export default {
  name: 'Home',
  data: function () {
    return {
      projectItems: null
    }
  },
  components: {
    PageHeader,
    CardProject
  },
  created () {
    // Get page content
    this.getProjectsContent()
  },
  mounted () {
    // eslint-disable-next-line
    setTimeout (() => {
      // Dispatch pageLoad event
      //
      const pageLoad = new CustomEvent('pageLoad')
      document.dispatchEvent(pageLoad)
    }, 250)
  },
  methods: {
    getProjectsContent: function () {
      // Portfolio items
      //
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'portfolio_item'), { orderings: '[document.first_publication_date]' }).then((response) => {
        this.projectItems = response.results
      })
    }
  }
}
</script>
